import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { Stack, Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import SharedDialog from '../../common/dialog/SharedDialog';
import GridContainer from '../../common/field/GridContainer';
import MUIInput from '../../common/field/MUIInput';
import MultiLangInput from '../../common/field/MultiLangInput';

const fullwidthSx = { gridColumn: '-1 / 1' }

const langsObj = {
    "EN": "",
    "ZH_CN": "",
    "ZH_HK": ""
}

const defaultData = {
    title: { ...langsObj },
    description: { ...langsObj },
    remarks: '',
}

const requiredKeys = ['title']

export default function SurveyDialog({
    isEdit,
    open,
    toggleOpen,
    handleSubmit,
    toggleDraft
}) {

    const savedSurveyFlow = useSelector(state => state.surveyFlow.ui.surveyFlow)

    const [data, setData] = useState({ ...defaultData })
    const [error, setError] = useState({ ...defaultData })

    const handleClose = () => toggleOpen(false);

    const handleChange = (e) => {
        if (e.target.value) {
            setData(d => ({ ...d, [e.target.name]: e.target.value }))
            setError(p => ({ ...p, [e.target.name]: '' }))
        } else {
            setData(d => ({ ...d, [e.target.name]: '' }))
            if (requiredKeys.includes(e.target.name)) {
                setError(p => ({ ...p, [e.target.name]: 'required' }))
            }
        }
    }

    const onChangeMultiLangInput = (objKey, key, value) => {
        if (value) {
            setData(p => ({ ...p, [objKey]: { ...langsObj, ...p[objKey], [key]: value } }))
            setError(p => ({ ...p, [objKey]: { ...langsObj, ...p[objKey], [key]: '' } }))
        } else {
            setData(p => ({ ...p, [objKey]: { ...langsObj, ...p[objKey], [key]: '' } }))
            if (requiredKeys.includes(objKey)) {
                setError(p => ({ ...p, [objKey]: { ...langsObj, ...p[objKey], [key]: 'required' } }))
            }
        }
    }

    const onSubmit = () => {
        for (let index = 0; index < requiredKeys.length; index++) {
            const element = requiredKeys[index];
            
            const keys = Object.keys(data?.[element])
            for (let i = 0; i < keys.length; i++) {
                if (!data?.[element]?.[keys[i]]) {
                    return onChangeMultiLangInput(element, keys[i], '')
                }
            }
        }

        handleSubmit(data)
        toggleDraft?.(true)
    }

    useEffect(() => {
        if (isEdit) setData(savedSurveyFlow)
        else setData({ ...defaultData })
    }, [savedSurveyFlow, isEdit])

    return (
        <SharedDialog
            maxWidth='md'
            open={open}
            onClose={handleClose}
            title={isEdit ? 'Edit Survey Flow' : 'Create Survey Flow'}
            content={
                <GridContainer>
                    <MultiLangInput
                        required
                        objKey='title'
                        label='Title'
                        langObj={{ ...langsObj, ...data?.title }}
                        error={error?.title}
                        onChangeMultiLangInput={onChangeMultiLangInput}
                    />
                    <MultiLangInput
                        objKey='description'
                        label='description'
                        langObj={{ ...langsObj, ...data?.description }}
                        error={error?.description}
                        onChangeMultiLangInput={onChangeMultiLangInput}
                    />
                    <MUIInput
                        sx={fullwidthSx}
                        name="remarks"
                        label="remarks"
                        value={data?.remarks || ''}
                        error={error?.remarks}
                        onChange={handleChange}
                    />
                </GridContainer>
            }
            actions={
                <Stack direction={'row'} gap={1}>
                    <Button variant='outlined' onClick={handleClose}>Cancel</Button>
                    <Button variant='contained' onClick={onSubmit}>Next</Button>
                </Stack>
            }
        />
    );
}
